<template>
  <div class="sky-page-function-view">
    <div class="page-function-toolbar wsp-width-100">
      <el-button type="primary" @click="handleReturnSelection">确定</el-button>
      <el-button icon="el-icon-refresh" @click="getData"></el-button>
      <el-input
        placeholder="请输入功能名称/价值进行查询"
        class="toolbar-input"
        size="medium"
        v-model="searchKeyword"
        @blur="searchReq"
        @change="searchReq"
        autocomplete="off"
      >
        <span slot="suffix" class="el-input__suffix" @click="searchReq"
          ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
        </span>
      </el-input>

      <el-pagination
        class="toolbar-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="handelPrev"
        @next-click="handelNext"
        :page-sizes="[20, 50, 100]"
        layout="total,sizes,prev,sp,next"
        :current-page="page"
        :page-size="pageSize"
        :total="pageTotal"
      >
      </el-pagination>
    </div>

    <el-table
      ref="function_table"
      :border="true"
      :data="viewData"
      :show-header="true"
      :column-drag-sortable="false"
      class="sky-host-dist"
      @selection-change="handleSelectionChange"
      height="78vh"
    >
      <el-table-column type="selection" width="55" :selectable="enableSelect"> </el-table-column>
      <el-table-column :label="$t('pocMng.functionList.featureName')" prop="name" width="215" show-overflow-tooltip>
        <div class="wsp-display-flex" slot-scope="scope" @click="showFuncDetail(scope.row)">
          <!-- <div v-if="scope.row.featureType === 'REQUIRED'" class="wsp-icon-bixuan bg-f13131 font-size-28"></div> -->
          <div class="sk-link--normal">{{ scope.row.featureName }}</div>
        </div>
      </el-table-column>

      <el-table-column
        label="功能类型"
        prop="featureType"
        width="85"
        :filter-method="filterFeatureType"
        :filters="[
          {
            text: '推荐',
            value: 'RECOMMEND'
          },
          {
            text: '必选',
            value: 'REQUIRED'
          },
          {
            text: '可选',
            value: 'OPTIONAL'
          }
        ]"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.featureType === 'REQUIRED'" type="warning">必选</el-tag>
          <el-tag v-if="scope.row.featureType === 'RECOMMEND'" type="primary">推荐</el-tag>
          <el-tag v-else type="success">可选</el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="使用者角色"
        prop="userRole"
        width="100"
        :filter-method="filterUserRole"
        :filters="[
          {
            text: '使用者',
            value: '使用者'
          },
          {
            text: '运维者',
            value: '运维者'
          },
          {
            text: '决策者',
            value: '决策者'
          }
        ]"
      >
      </el-table-column> -->
      <!-- <el-table-column
        label="桌面架构"
        prop="desktopArch"
        width="90"
        :filter-method="filterDesktopArch"
        :filters="[
          {
            text: 'VDI',
            value: 'VDI'
          },
          {
            text: 'IDV',
            value: 'IDV'
          },
          {
            text: 'TCI',
            value: 'TCI'
          },
          {
            text: 'PC',
            value: 'PC'
          }
        ]"
      >
      </el-table-column> -->
      <el-table-column
        :label="$t('pocMng.functionList.length')"
        prop="competitiveness"
        width="85"
        show-overflow-tooltip
        :filter-method="filterCompetitiveness"
        :filters="[
          {
            text: '优势',
            value: '优势'
          },
          {
            text: '劣势',
            value: '劣势'
          },
          {
            text: '持平',
            value: '持平'
          }
        ]"
        v-if="!isChannel"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.competitiveness === '优势'" type="success">优势</el-tag>
          <el-tag v-else-if="scope.row.competitiveness === '劣势'" type="info">劣势</el-tag>
          <el-tag v-else-if="scope.row.competitiveness === '持平'" type="info">持平</el-tag>
          <el-tag v-else type="warning">未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('pocMng.functionList.valueDesc')"
        :filter-method="filterValueDesc"
        :filters="valueDescList"
        show-overflow-tooltip
        prop="valueDesc"
        width="180"
      >
      </el-table-column>
      <el-table-column :label="$t('pocMng.functionList.resolveIssues')" show-overflow-tooltip prop="resolveIssues">
      </el-table-column>
      <!-- <el-table-column :label="$t('pocMng.functionList.productVersion')" show-overflow-tooltip prop="productVersion">
      </el-table-column> -->
      <el-table-column
        :label="$t('pocMng.functionList.limitDesc')"
        show-overflow-tooltip
        prop="limitDesc"
        v-if="!isChannel"
      >
      </el-table-column>
      <!-- <el-table-column label="操作" prop="name" width="80" v-if="!isChannel">
        <div class="wsp-display-flex" slot-scope="scope" @click="feedbackLimit(scope.row)">
          <div class="sk-link--normal">限制反馈</div>
        </div>
      </el-table-column> -->
    </el-table>

    <el-drawer
      ref="drawer"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="handleCloseDrawer"
      direction="rtl"
      class="content-feature-drawer-detail"
    >
      <div
        style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 60px;"
        class="wsp-padding-tb-12"
      >
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template><span>功能说明</span> </template>
          </div>
        </div>
      </div>
      <div class="feature-detail-content">
        <div class="feature-filed-detail-item">
          <div class="item-label">功能名：</div>
          <div class="item-value">{{ showFunViewDetail.featureName }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">功能类型：</div>
          <div class="item-value">
            <template>
              <el-tag v-if="showFunViewDetail.featureType === 'REQUIRED'" type="warning">{{
                lang.t(featureTypeDictionary[showFunViewDetail.featureType]).label
              }}</el-tag>
              <el-tag v-else type="success">{{
                lang.t(featureTypeDictionary[showFunViewDetail.featureType]).label
              }}</el-tag>
            </template>
          </div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">业务诉求【主打价值】：</div>
          <div class="item-value">{{ showFunViewDetail.valueDesc }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">预期效果：</div>
          <div class="item-value">{{ showFunViewDetail.expectedOutcome }}</div>
        </div>
        <div class="feature-filed-detail-item" v-if="!isChannel">
          <div class="item-label">竞争力：</div>
          <div class="item-value">
            <template>
              <el-tag v-if="showFunViewDetail.competitiveness === '优势'" type="success">
                {{ showFunViewDetail.competitiveness }}</el-tag
              >
              <el-tag v-else-if="showFunViewDetail.competitiveness === '持平'" type="info">
                {{ showFunViewDetail.competitiveness }}</el-tag
              >
              <el-tag v-else type="danger"> {{ showFunViewDetail.competitiveness }}</el-tag>
            </template>
          </div>
        </div>
        <div class="feature-filed-detail-item" v-if="!isChannel">
          <div class="item-label">友商情况：</div>
          <div class="item-value">{{ showFunViewDetail.competitiveComparison }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">测试说明：</div>
          <div class="item-value">{{ showFunViewDetail.schemeDesign }}</div>
        </div>
        <div class="feature-filed-detail-item" v-if="!isChannel">
          <div class="item-label">相关限制说明：</div>
          <div class="item-value">{{ showFunViewDetail.limitDesc }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">解决客户问题：</div>
          <div class="item-value">{{ showFunViewDetail.resolveIssues }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">价值描述：</div>
          <div class="item-value">{{ showFunViewDetail.configStep }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">视频演示：</div>
          <div class="item-value">{{ showFunViewDetail.video }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">PPT演示：</div>
          <div class="item-value">{{ showFunViewDetail.ppt }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">关联测试用例：</div>
          <div class="item-value">
            <div v-for="item in showFunViewDetail.testCaseList" :key="item">
              <span>{{ item.testCaseName }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { Table, TableColumn, Button, Drawer, Pagination, Row, Col, Tag, Input } from 'element-ui'

import { extend } from 'sk-ui/lib/utils/util.js'

import { getSpecFeatureList, getSpecFeatureInfo } from '@/api/businessResearch'
import { getDetail } from '@/api/deliveryProject'
import lang from '@/lang'
import limit from '@/store/modules/limitMng/metaData/limit'
import dictionary from '@/utils/dictionary'
export default {
  name: 'SkyFunctionTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Pagination.name]: Pagination,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Input.name]: Input
  },
  props: {
    projectId: {
      type: String
    },
    productVersionList: {
      type: Array,
      default: function() {
        return []
      }
    },
    selectFeatrueIdList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    selectFeatrueIdList: {
      handler: function(value) {
        this.defaultSelectFunction = value
        this.reloadData()
      }
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      productVersion: null,
      showFunViewDetail: {},
      specFeatureList: [],
      viewData: [],
      searchKeyword: null,
      defaultSelectFunction: [],
      selectFunction: [],
      valueMap: {},
      pageSelectFunction: [],
      valueDescList: [],
      pageTotal: 0,
      pageSize: 5,
      page: 1,
      featureTypeDictionary: dictionary.featureType,
      lang: lang,
      reqParams: {
        matchArr: [],
        page: 0,
        limit: 20
      },
      isChannel: this.$store.getters.baseInfo.channel
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    refushTable() {
      this.getData()
    },
    enableSelect(row, index) {
      if (this.selectFeatrueIdList.includes(row.id)) {
        return false
      }
      return true
    },
    getSelectId() {
      var idArr = []
      for (const iterator of this.selectFunction) {
        idArr.push(iterator.id)
      }
      return idArr
    },
    filterUserRole(value, row) {
      if (!row.userRole) {
        return false
      }
      return row.userRole.includes(value)
    },
    filterCompetitiveness(value, row) {
      if (!row.competitiveness) {
        return false
      }
      return row.competitiveness === value
    },
    filterDesktopArch(value, row) {
      if (!row.desktopArch) {
        return false
      }
      return row.desktopArch.includes(value)
    },
    filterValueDesc(value, row) {
      if (!row.valueDesc) {
        return false
      }
      return row.valueDesc === value
    },
    filterFeatureType(value, row) {
      if (!row.featureType) {
        return false
      }
      return row.featureType === value
    },
    reloadData() {
      this.searchKeyword = null
      this.getData()
    },
    searchReq() {
      this.viewData = this.specFeatureList.filter(
        data => !this.searchKeyword || data.featureName.toLowerCase().includes(this.searchKeyword.toLowerCase())
      )
      this.getData()
    },
    reloadTableSelect() {
      this.$nextTick(() => {
        for (const iterator of this.specFeatureList) {
          if (!this.valueMap[iterator.valueDesc]) {
            this.valueMap[iterator.valueDesc] = {
              text: iterator.valueDesc,
              value: iterator.valueDesc
            }
          }
          // if (this.defaultSelectFunction && this.defaultSelectFunction.length > 0) {
          //   if (this.defaultSelectFunction.includes(iterator.id)) {
          //     this.$refs.function_table.toggleRowSelection(iterator)
          //   }
          // }
        }
        this.valueDescList = []
        for (var iterator in this.valueMap) {
          this.valueDescList.push(this.valueMap[iterator])
        }
      })
    },
    removeAllNoPageFeatureId(allData, removeSourceArr) {
      var source_arr = []
      for (const element of allData) {
        source_arr.push(element.id)
      }
      const intersection = source_arr.filter(item => removeSourceArr.includes(item))
      return intersection
    },
    getData() {
      getDetail({ id: this.projectId }).then(res => {
        var productVersion = res.data.content.productVersion
        this.reqParams.matchArr = []
        this.reqParams.page = this.page - 1

        if (this.searchKeyword) {
          this.reqParams.matchArr.push({
            type: 'FUZZY',
            fieldNameArr: ['featureName', 'valueDesc'],
            value: this.searchKeyword,
            matchRule: 'FULL'
          })
        }
        this.reqParams.matchArr.push({
          type: 'EXACT',
          fieldName: 'productId',
          valueArr: [productVersion],
          matchRule: 'EQ'
        })

        this.valueMap = {}
        getSpecFeatureList(this.reqParams).then(res => {
          this.specFeatureList = res.data.content.itemArr
          this.viewData = this.specFeatureList

          this.pageTotal = res.data.content.total
          this.reloadTableSelect()
        })
      })
    },
    handleReturnSelection() {
      this.$emit('selectAddConfirm', { selectFunction: this.selectFunction })
    },
    handleSelectionChange(val, row) {
      this.selectFunction = val
    },
    showFuncDetail(rowParams) {
      getSpecFeatureInfo({ id: rowParams.id }).then(res => {
        this.dialogVisible = true
        this.showFunViewDetail = res.data.content
      })
    },
    feedbackLimit(rowParams) {
      const props = {
        params: { specId: rowParams.id },
        extraParams: {
          featureName: rowParams.featureName
        }
      }
      const limitCopy = extend(true, {}, limit)
      limitCopy.toolbar.items[1].label = '  当前功能：' + rowParams.featureName
      this.$store.dispatch('OpenDetailDialog', {
        metaData: limitCopy,
        props
      })
    },
    handleCloseDrawer() {
      this.showFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-function-view) {
  height: 100%;
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
  .el-table .cell {
    padding-left: 3px;
  }
  .content-feature-drawer-detail {
    height: 100%;

    .feature-detail-content {
      padding: 12px 24px;
      overflow-y: scroll;
      height: 86vh;
      .feature-filed-detail-item {
        display: flex;
        line-height: 28px;
        .item-label {
          text-align: right;
          font-weight: 600;
          width: 20%;
        }
        .item-value {
          width: 80%;
          word-break: break-all;
          white-space: pre-wrap;
          .item-tag {
            margin: 0 3px;
          }
        }
      }
    }
  }
}
</style>
